import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";
import { IProductFieldsFragment } from "@govlaunch/product/src/fragments/__generated__/ProductFieldsFragment.generated";

export type PreviewMode = "basic" | "makers";

export type ViewMode = "basic" | "makers";

export default function getProductViewMode(
  _: ISelfieQuery["selfie"] | null,
  product: IProductFieldsFragment,
  preview: PreviewMode | null,
  viewerIsMember?: boolean | null,
): ViewMode {
  if (preview && viewerIsMember) {
    return preview;
  }

  if (product.enrichedProfile) {
    return "makers";
  }

  return "basic";
}
